import React from 'react';

// Styles & Assets
import styles from './MediaDate.module.css';
import pdgSVG from '../../../assets/icons/pdf.svg';

// Components
import MediaDialog from '../MediaDialog/MediaDialog';
import ImageDialog from '../ImageDialog/ImageDialog';

// Interfaces
import { IMessage } from '../../../interfaces/Chat';
interface Props {
    messages: IMessage[],
    isGalleryMode?: boolean;
}

const MediaDate: React.FC<Props> = ({ messages, isGalleryMode = true }) => {
    return (
        <div className={`${isGalleryMode ? styles.grid : styles.flex}`}>
            {messages.map(m =>
                m.dataType === 'IMAGE' ?
                    <ImageDialog
                        key={m.id}
                        date={m.timestamp}
                        url={m.dataURL}
                        className={styles.buttonImage}
                    />
                    : m.dataType === 'VIDEO' ?
                        <MediaDialog
                            key={m.id}
                            msg={m}
                            className={styles.videoPreview}
                        />
                        : m.dataType === 'DOCUMENT' ?
                            <button key={m.id} className={styles.pdfPreview} onClick={() => window.open(m.dataURL)}>
                                <img src={pdgSVG} className={styles.pdfIcon} alt='pdf icon' />
                                <p className={styles.size}>{m.customMetadata?.attachments?.[0]?.size ?? 0} KB</p>
                            </button>
                            : null
            )}
        </div>
    );
};

export default MediaDate;